import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Mail, Inbox, MailOpen, FileText } from 'lucide-react';
import { Badge } from '@wit-support/ui';
import { cn } from './lib/cn.js';
import { capitalize } from './lib/capitalize.js';
const ICONS = {
    gmail: Mail,
    imap: Inbox,
    smtp_inbound: MailOpen,
    web_form: FileText,
};
/**
 * Channel-kind pill. Colours come from `--color-channel-<kind>-{bg,fg}`
 * defined in `@wit-support/ui/theme.css`. We apply them via inline `style`
 * so Tailwind's JIT doesn't need to statically enumerate every kind.
 */
export const ChannelBadge = React.forwardRef(({ kind, size = 'md', iconOnly = false, className }, ref) => {
    const Icon = ICONS[kind];
    const label = capitalize(kind);
    const iconSize = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';
    const style = {
        backgroundColor: `var(--color-channel-${kind}-bg)`,
        color: `var(--color-channel-${kind}-fg)`,
    };
    return (_jsxs(Badge, { ref: ref, size: size, variant: "neutral", "aria-label": iconOnly ? label : undefined, className: cn('border-transparent', iconOnly && (size === 'sm' ? 'px-1' : 'px-1.5'), className), style: style, children: [_jsx(Icon, { className: iconSize, "aria-hidden": "true" }), iconOnly ? null : _jsx("span", { children: label })] }));
});
ChannelBadge.displayName = 'ChannelBadge';
//# sourceMappingURL=channel-badge.js.map